import varAxios from "../../Comman/axios";
import {UpdateAlarmSoundUrl,UpdateCompressionAudioUrl,GetAlarmSoundUrl, UpdateAbortAudioUrl, UpdateEditAudioUrl,
    UpdateNormalSoundUrl, UpdateEmergencySoundUrl} from '../../Comman/apiEndPoints';

export const Fetch_Alarm_Sound_Data = "Fetch_Alarm_Sound_Data";
export const Update_Alarm_Sound_Success = "Update_Alarm_Sound_Success";
export const GET_ALARM_SOUND_REQUEST = "GET_ALARM_SOUND_REQUEST";

export function getAlarmSound() {
    return(dispatch) =>{
        dispatch(getAlarmSoundRequest(true)); 
       return varAxios.get(GetAlarmSoundUrl)
       .then(response => {
          dispatch(
            fetchAlarmSoundData({
                isLoading : false,
                errorCode : response.data.errorCode,
                statusCode : response.data.statusCode,
                alarmSoundList : response.data.GlobalSettings
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function getAlarmSoundRequest(isLoading){
    return {
        type : GET_ALARM_SOUND_REQUEST,
        isLoading
    }
}
export function fetchAlarmSoundData({isLoading,errorCode,statusCode,alarmSoundList}) {
    return{
        type : Fetch_Alarm_Sound_Data,
        isLoading,
        errorCode,
        statusCode,
        alarmSoundList
    }
}

export function updateAlarmSound(formData) {
    return (dispatch) => {
        dispatch(getAlarmSoundRequest(true));
        return varAxios.post(UpdateAlarmSoundUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateAlarmSoundSuccess(false,response.data.errorCode,response.data.statusCode,
                        response.data.Message,response.data.Value
                   )
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }

  export function updateCompressionAudio(formData) {
    return (dispatch) => {
        dispatch(getAlarmSoundRequest(true));
        return varAxios.post(UpdateCompressionAudioUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateAlarmSoundSuccess(false,response.data.errorCode,response.data.statusCode,
                        response.data.Message,response.data.Value
                   )
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateAbortAudio(formData) {
    return (dispatch) => {
        dispatch(getAlarmSoundRequest(true));
        return varAxios.post(UpdateAbortAudioUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateAlarmSoundSuccess(false,response.data.errorCode,response.data.statusCode,
                        response.data.Message,response.data.Value
                   )
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function UpdateEditAudio(formData) {
    return (dispatch) => {
        dispatch(getAlarmSoundRequest(true));
        return varAxios.post(UpdateEditAudioUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateAlarmSoundSuccess(false,response.data.errorCode,response.data.statusCode,
                        response.data.Message,response.data.Value
                   )
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }

  export function UpdateNormalSound(formData) {
    return (dispatch) => {
        dispatch(getAlarmSoundRequest(true));
        return varAxios.post(UpdateNormalSoundUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateAlarmSoundSuccess(false,response.data.errorCode,response.data.statusCode,
                        response.data.Message,response.data.Value
                   )
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function UpdateEmergencySound(formData) {
    return (dispatch) => {
        dispatch(getAlarmSoundRequest(true));
        return varAxios.post(UpdateEmergencySoundUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateAlarmSoundSuccess(false,response.data.errorCode,response.data.statusCode,
                        response.data.Message,response.data.Value
                   )
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateAlarmSoundSuccess(isLoading,errorCode,statusCode,message,value) {
      return{
            type : Update_Alarm_Sound_Success,
            isLoading,
            errorCode,
            statusCode,
            message,
            value
      }
  }